<template>
  <div class="classic-ebike-page">
    <!-- Hero -->
    <section class="hero-section">
      <picture>
        <source
            media="(max-width:900px)"
            :srcset="imgUrlPrefix + 'm-sec1_hero.jpg'"
        />

        <img
            class="hero-img"
            :src="imgUrlPrefix + 'sec1_hero.jpg'"
            alt="METTA Classic EZI Mini F14"
        />
      </picture>
      <div class="hero-copy">
        <div class="eyebrow">

            <img

                src="/assets/images/classicEbike/hero-logo.png"

                alt="METTA 易行系列"

            />

        </div>
        <h1 class="hero-title">MiniFoLd F14<br />METTA</h1>
        <p>从旷野到城市<br />从 MiniFoLd F14 METTA<br />看METTA“玩车生态”</p>
      </div>
    </section>

    <!-- Feature 1 -->
    <section class="feature-section feature-light">
      <div class="feature-img-wrap">
        <picture>

            <source

                media="(max-width:900px)"

                :srcset="imgUrlPrefix + 'm-sec2_light.jpg'"

            />

            <img

                :src="imgUrlPrefix + 'sec2_light.jpg'"

                alt="前灯"

            />

        </picture>
      </div>
      <div class="feature-copy right-copy">
        <h2>前灯</h2>
        <p class="pc-text">

  提供明亮、节能的照明，提升夜间骑<br>

  行安全性。它们持久耐用、低功耗且<br>

  耐候性强，确保清晰视野的同时，还<br>

  能延长电池寿命

</p>

<p class="mobile-text">

  提供明亮、节能的照明<br>

  提升夜间骑行安全性<br>

  它们持久耐用、低功耗且耐候性强<br>

  确保清晰视野的同时还能延长电池寿命

</p>
      </div>
    </section>

    <!-- Feature 2 -->
    <section class="feature-section feature-dark">
      <picture>
        <source
            media="(max-width:900px)"
            :srcset="imgUrlPrefix + 'm-sec3_motor.jpg'"
        />

        <img
            class="full-img"
            :src="imgUrlPrefix + 'sec3_motor.jpg'"
            alt="发动机"
        />
      </picture>
      <div class="dark-copy">
        <h2>发动机</h2>
        <p class="pc-text">

  AKM85SX 36V 250W 后轮毂电机为折<br>

  叠电动自行车提供平稳的加速、安静<br>

  的运行和高效的动力。其紧凑的设计<br>

  确保了轻量化性能，同时保持了可靠<br>
  
  的扭矩，满足城市通勤的需求

</p>

<p class="mobile-text">

  AKM85SX 36V 250W 后轮毂电机<br>

  为折叠电动自行车提供平稳的加速<br>

  安静的运行和高效的动力<br>

  其紧凑的设计确保了轻量化性能<br>

  同时保持了可靠的扭矩，满足城市通勤的需求

</p>
      </div>
    </section>

    <!-- Feature 3 -->
    <section class="display-section">
      <div class="display-copy">
        <h2>显示器</h2>
        <p class="pc-text">

 DS M210 显示屏为折叠电动自行车提供清晰直观的控<br>

  制界面，可显示速度、电池电量和助力模式。其紧凑<br>

  时尚的设计兼具耐候性和易用性，提升了骑行便利性

</p>

<p class="mobile-text">

  DS M210 显示屏为折叠电动自行车<br>

  提供清晰直观的控制界面<br>

  可显示速度、电池电量和助力模式<br>

  其紧凑时尚的设计兼具耐候性和易用性<br>

  提升了骑行便利性

</p>
      </div>
      <picture>
        <source
            media="(max-width:900px)"
            :srcset="imgUrlPrefix + 'm-sec4_display.jpg'"
        />

        <img
            :src="imgUrlPrefix + 'sec4_display.jpg'"
            alt="显示器"
        />
      </picture>
    </section>

    <!-- Feature 4 -->
    <section class="seat-section">
      <div class="seat-copy">
        <h2>便携鞍座</h2>
        <p class="pc-text">

  折叠式电动自行车的舒适便携鞍座<br>

  在确保长途骑行符合人体工学的同时也兼具轻便易调节的特点<br>

  其快拆设计，方便拆卸存放或运输

</p>

<p class="mobile-text">

  折叠式电动自行车的舒适便携鞍座<br>

  在确保长途骑行符合人体工学的同时<br>

  也兼具轻便易调节的特点<br>

  其快拆设计，方便拆卸存放或运输

</p>
      </div>
      <picture>
        <source
            media="(max-width:900px)"
            :srcset="imgUrlPrefix + 'm-sec5_saddle.jpg'"
        />

        <img
            :src="imgUrlPrefix + 'sec5_saddle.jpg'"
            alt="便携鞍座"
        />
      </picture>
    </section>

    <!-- Specs -->
    <section class="spec-section">

        <picture>
            <source
                media="(max-width:900px)"
                :srcset="imgUrlPrefix + 'm-sec6_spec.jpg'"
            />

            <img
                class="spec-img"
                :src="imgUrlPrefix + 'sec6_spec.jpg'"
                alt="METTA 参数图"
            />
        </picture>

    </section>

    <!-- Lifestyle -->
    <!-- <CarLifeComponent :bg-img="carLifeBg" />-->
    <section class="final-section">

        <picture>
            <source
                media="(max-width:900px)"
                :srcset="imgUrlPrefix + 'm-sec7_final.jpg'"
            />

            <img
                class="final-img"
                :src="imgUrlPrefix + 'sec7_final.jpg'"
                alt="METTA Final"
            />
        </picture>

    </section>
   

  </div>
</template>

<script>

import CarLifeComponent from '../components/CarLifeComponent.vue'

export default {

  name: 'ClassicEbike',

  components: {

    CarLifeComponent,

  },

  data() {

    return {

      imgUrlPrefix: '/assets/images/classicEbike/',

    }

  },

  computed: {

    carLifeBg() {

      return this.imgUrlPrefix + 'sec7_life.jpg'

    },

  },

}

</script>

<style scoped>
.final-section{

    width:100%;

    overflow:hidden;

    background:#000;

}

.final-img{

    width:100%;

    display:block;

}
.classic-ebike-page {
  background: #f4f4f4;
  color: #1c1c1c;
  font-family: 'TsangerYunHei', sans-serif;
  font-weight: 200;
  overflow-x: hidden;
  padding-top: 2.7vw;
}

.hero-section {
  position: relative;
  height: calc(100vh - 2.7vw);
  min-height: 620px;
  background: #f5f5f5;
  overflow: hidden;
}

.hero-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.hero-copy {
  position: absolute;
  top: 14%;
  left: 8%;
  color: #161616;
}

.eyebrow {
   margin-bottom:1vw;

    }

    .eyebrow img{

    display:block;

    width:12vw;

    min-width:120px;

    max-width:220px;

    height:auto;
}

.hero-title {

  font-family:'TsangerYunHei',sans-serif;

    font-size:clamp(48px,4.35vw,84px);

    font-weight:100;

    line-height:1.1;

    letter-spacing:0;

    color:#222222;

    margin-bottom:1vw;

}

.hero-copy p {
  font-family:'TsangerYunHei',sans-serif;

    font-size:clamp(18px,1.67vw,32px);

    font-weight:200;

    color:#666666;

    line-height:1.7;
}

.feature-section,
.display-section,
.seat-section {
  position: relative;
  min-height: 650px;
  overflow: hidden;
}

.feature-light {
  display: grid;
  grid-template-columns: 56% 44%;
  background: #eeeeee;
}

.feature-img-wrap {
  height: 100%;
  overflow: hidden;
}

.feature-img-wrap img,
.display-section img,
.seat-section img,
.life-section img,
.full-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.feature-copy {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 12%;
}

.feature-copy h2,
.display-copy h2,
.seat-copy h2,
.dark-copy h2 {
  font-family:'TsangerYunHei',sans-serif;

  font-size: clamp(32px,2.5vw,48px);

  font-weight:200;

  line-height:1.2;

  letter-spacing:0;

  margin-bottom:1vw;
}

.feature-copy p,
.display-copy p,
.seat-copy p,
.dark-copy p {
  font-family:'TsangerYunHei',sans-serif;

  /* 与最后一屏正文一致 */

  font-size: clamp(16px,1.25vw,24px);

  font-weight:200;

  line-height:1.7;

  color:#777;

  max-width:440px;
}

.feature-dark {
  background: #111;
  height: 720px;
}

.dark-copy {
  position: absolute;
  right: 9%;
  top: 38%;
  width: 30%;
  color: #fff;
}

.dark-copy p {
  color: rgba(255,255,255,0.58);
}

.display-section {
  min-height: 640px;
  background: #f4f4f4;
}

.display-section img {
  object-position: center;
}

.display-copy {
  position: absolute;
  left: 8%;
  top: 18%;
  z-index: 2;
}

.seat-section {
  min-height: 580px;
  background: #e8e8e6;
}

.seat-copy {
  position: absolute;
  left: 8%;
  top: 14%;
  z-index: 2;
}

.spec-section {
  background: #fff;
  padding: 0;
}

.spec-img {

  width: 100%;

  display: block;

}

.mobile-text {

  display: none;

}



@media (max-width:900px){

.classic-ebike-page{
    padding-top:56px;
    background:#ededed;
}

/* 通用 section */

.hero-section,
.feature-section,
.display-section,
.seat-section,
.feature-dark,
.spec-section,
.final-section{

    height:auto;
    min-height:0;
    display:flex;
    flex-direction:column;
    background:#ededed;
}

/* hero */

.hero-section{
    position:relative;
}

.hero-copy{
    position:absolute;
    top:7%;
    left:5%;
    z-index:2;
    padding:0;
    text-align:left;
    background:transparent;
}

.eyebrow{
    margin-bottom:14px;
}

.eyebrow img{
    width:36vw;
    max-width:none;
    min-width:0;
}

.hero-title{

    font-family:'TsangerYunHei',sans-serif;

    font-size:12.8vw;

    line-height:1.1;

    font-weight:200;

    color:#464646;

    margin-bottom:4.8vw;

    white-space:nowrap;
}

.hero-copy p{

    font-family:'TsangerYunHei',sans-serif;

    font-size:6.4vw;

    line-height:1.7;

    font-weight:200;

    color:#464646;
}

.hero-img{

    width:100%;
    height:auto;
    object-fit:cover;
}

/* feature layout */

.feature-light{
    display:block;
}

/* 所有文字区 */

.feature-copy,
.display-copy,
.seat-copy,
.dark-copy{
    position:absolute;
    top:8%;
    left:50%;
    transform:translateX(-50%);
    z-index:2;

    width:82%;
    padding:0;

    background:transparent;
    text-align:center;
    color:#222;
}


/* 标题 */

.feature-copy h2,

.display-copy h2,

.seat-copy h2,

.dark-copy h2{

    font-size:7.2vw;

    line-height:1.22;

    margin-bottom:4.8vw;

    font-weight:200;

    color:#000;

    white-space:nowrap;

}

/* 正文 */

.feature-copy p,

.display-copy p,

.seat-copy p,

.dark-copy p{

    display:block;

    font-size:3.6vw;

    line-height:1.7;

    font-weight:200;

    color:rgba(0,0,0,0.75);

    max-width:none;

    margin:auto;

    white-space:nowrap;

}

/* 图片 */

.feature-img-wrap img,
.display-section img,
.seat-section img,
.full-img{

    width:100%;
    height:auto;

    display:block;

    object-fit:cover;
}

/* 显示器/鞍座顺序修正 */


/* 参数图 */

.spec-section{

    padding:0;
    background:#fff;
}

.spec-img{

    width:100%;
    display:block;
}

/* 最后一屏 */

.final-section{

    background:#000;
}

.final-img{

    width:100%;
    display:block;
}

}
.hero-section,

.feature-section,

.display-section,

.seat-section,

.feature-dark{

    position:relative;

}
.pc-text {

  display: none !important;

}

.mobile-text {

  display: block !important;

}
</style>
